module.exports = __webpack_public_path__ + "img/TECNOLOGIA-S-CROSS-4.75f5d8be.jpg";